/**
 * Copyright IBM Corp. 2022, 2026
 */

import ReactPlayer from 'react-player'
import { vercelSplit } from '@web/cms'
import { getModalType } from 'app/[locale]/abm/_utils/get-modal-type'
import s from './abm-modal-content.module.css'

interface ABMModalContentProps {
	href: string
}

const ABMModalContent = ({ href }: ABMModalContentProps) => {
	const parsedHref = vercelSplit(href)
	const modalType = getModalType(parsedHref)

	switch (modalType) {
		case 'pdf':
			return (
				<embed
					className={s.embed}
					src={vercelSplit(parsedHref)}
					type="application/pdf"
					data-theme="dark"
				/>
			)
		case 'video':
			return (
				<div className={s.video} data-theme="dark">
					<ReactPlayer
						url={parsedHref}
						width="auto"
						height="100%"
						controls
						playsInline
						style={{
							borderRadius: 8,
							overflow: 'hidden',
						}}
					/>
				</div>
			)
	}
}

export { ABMModalContent }
